/**
 * DevExtreme (esm/__internal/grids/grid_core/keyboard_navigation/const.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var ATTRIBUTES = {
    ariaColIndex: "aria-colindex",
    dragCell: "dx-drag-cell"
};
export var ROWS_VIEW_CLASS = "rowsview";
export var EDIT_FORM_CLASS = "edit-form";
export var GROUP_FOOTER_CLASS = "group-footer";
export var ROW_CLASS = "dx-row";
export var DATA_ROW_CLASS = "dx-data-row";
export var GROUP_ROW_CLASS = "dx-group-row";
export var HEADER_ROW_CLASS = "dx-header-row";
export var EDIT_FORM_ITEM_CLASS = "edit-form-item";
export var MASTER_DETAIL_ROW_CLASS = "dx-master-detail-row";
export var FREESPACE_ROW_CLASS = "dx-freespace-row";
export var VIRTUAL_ROW_CLASS = "dx-virtual-row";
export var MASTER_DETAIL_CELL_CLASS = "dx-master-detail-cell";
export var EDITOR_CELL_CLASS = "dx-editor-cell";
export var DROPDOWN_EDITOR_OVERLAY_CLASS = "dx-dropdowneditor-overlay";
export var COMMAND_EXPAND_CLASS = "dx-command-expand";
export var ADAPTIVE_COLUMN_NAME_CLASS = "dx-command-adaptive";
export var COMMAND_SELECT_CLASS = "dx-command-select";
export var COMMAND_EDIT_CLASS = "dx-command-edit";
export var COMMAND_CELL_SELECTOR = "[class^=dx-command]";
export var CELL_FOCUS_DISABLED_CLASS = "dx-cell-focus-disabled";
export var DATEBOX_WIDGET_NAME = "dxDateBox";
export var FOCUS_STATE_CLASS = "dx-state-focused";
export var WIDGET_CLASS = "dx-widget";
export var REVERT_BUTTON_CLASS = "dx-revert-button";
export var FOCUSED_CLASS = "dx-focused";
export var FAST_EDITING_DELETE_KEY = "delete";
export var INTERACTIVE_ELEMENTS_SELECTOR = '\n  input:not([type="hidden"]):not([disabled]),\n  textarea:not([disabled]),\n  a:not([disabled]),\n  select:not([disabled]),\n  button:not([disabled]),\n  [tabindex]:not([disabled]),\n  .dx-checkbox:not([disabled],.dx-state-readonly)\n';
export var NON_FOCUSABLE_ELEMENTS_SELECTOR = "".concat(INTERACTIVE_ELEMENTS_SELECTOR, ", .dx-dropdowneditor-icon");
export var EDIT_MODE_FORM = "form";
export var FOCUS_TYPE_ROW = "row";
export var FOCUS_TYPE_CELL = "cell";
export var COLUMN_HEADERS_VIEW = "columnHeadersView";
export var ROWS_VIEW = "rowsView";
export var FUNCTIONAL_KEYS = ["shift", "control", "alt"];
